// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../Types/generated-types'

import gql from 'graphql-tag'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type HasRecentBookingsQueryVariables = Types.Exact<{ [key: string]: never }>

export type HasRecentBookingsQuery = {
  __typename?: 'Query'
  recentBookings: Array<{ __typename?: 'Booking'; id: number }>
}

export const HasRecentBookingsDocument = gql`
  query HasRecentBookings {
    recentBookings(pagination: { pageSize: 1 }) {
      id
    }
  }
`

export function useHasRecentBookingsQuery(
  options?: Omit<Urql.UseQueryArgs<HasRecentBookingsQueryVariables>, 'query'>
) {
  return Urql.useQuery<HasRecentBookingsQuery, HasRecentBookingsQueryVariables>({
    query: HasRecentBookingsDocument,
    ...options,
  })
}
